import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { activeFilter, columnConfigs } from './listConfig';

const ListHappyHours: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getHappyHoursData } = useService();

	return (
		<DataList
			fetchData={getHappyHoursData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			entity={LIST_ENTITY_NAMES.HAPPY_HOURS}
			initialFilters={createInitialFilters(activeFilter)}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default ListHappyHours;
